import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { FeatureAccessService } from 'src/app/Services/feature-access.service';

@Component({
  selector: 'ze-integration-view',
  templateUrl: './integration-view.component.html',
  styleUrls: ['./integration-view.component.scss']
})
export class IntegrationViewComponent implements OnInit {
  activeTab: string = 'github';

  private subscriptions: Subscription = new Subscription();

  constructor(private route: ActivatedRoute,
    private router: Router,
    private featureAccessService: FeatureAccessService) { }

  ngOnInit() {
    this.updateActiveTab();
    this.subscriptions.add(this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateActiveTab()));
    this.updateActiveTab();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions to avoid memory leaks
    this.subscriptions.unsubscribe();
  }

  updateActiveTab() {
    const child = this.route.firstChild;
    if (!child) {
      // Dynamic default redirect based on access
      this.subscriptions.add(this.featureAccessService.nonProjectAccessMap.subscribe(map => {
        if (map === null) return; // Still loading

        if (this.featureAccessService.isNonProjectVisible('GITHUB_INTEGRATION')) {
          this.navigateTo('github');
        } else if (this.featureAccessService.isNonProjectVisible('JIRA_INTEGRATION')) {
          this.navigateTo('jira');
        } else if (this.featureAccessService.isNonProjectVisible('AGILE_INTEGRATION')) {
          this.navigateTo('agile-studio');
        } else if (this.featureAccessService.isNonProjectVisible('SLACK_INTEGRATION')) {
          this.navigateTo('slack');
        }
      }));
      return;
    }

    const path = child.snapshot.routeConfig.path;
    switch (path) {
      case 'github':
      case 'jira':
      case 'agile-studio':
      case 'slack':
        this.activeTab = path;
        break;
      default:
        this.activeTab = 'github';
    }
  }

  navigateTo(tab: string) {
    this.router.navigate([tab], { relativeTo: this.route });
  }
}
